import { render, staticRenderFns } from "./ColorSections.vue?vue&type=template&id=d1329c8c&"
import script from "./ColorSections.vue?vue&type=script&lang=js&"
export * from "./ColorSections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports